export default {"src":"/_next/static/media/tennis.63d5f01e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};